module.exports = __webpack_public_path__ + "static/media/volunteer-access.8c7457a1.png";